import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockIconUnlocked = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.9993 3.33333C10.485 2.15606 9.36623 2 7.99935 2C6.1584 2 4.66602 3.49238 4.66602 5.33333V6.68586M7.99935 9.66667V11M4.66602 6.68586C4.9803 6.66667 5.36774 6.66667 5.86602 6.66667H10.1327C11.2528 6.66667 11.8128 6.66667 12.2407 6.88465C12.617 7.0764 12.9229 7.38236 13.1147 7.75869C13.3327 8.18651 13.3327 8.74656 13.3327 9.86667V10.8C13.3327 11.9201 13.3327 12.4802 13.1147 12.908C12.9229 13.2843 12.617 13.5903 12.2407 13.782C11.8128 14 11.2528 14 10.1327 14H5.86602C4.74591 14 4.18586 14 3.75803 13.782C3.38171 13.5903 3.07575 13.2843 2.884 12.908C2.66602 12.4802 2.66602 11.9201 2.66602 10.8V9.86667C2.66602 8.74656 2.66602 8.18651 2.884 7.75869C3.07575 7.38236 3.38171 7.0764 3.75803 6.88465C3.99554 6.76364 4.2738 6.7098 4.66602 6.68586Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLockIconUnlocked;
